import { Box } from "@mui/system";
import { FC, useEffect, useState } from "react";
import Slider from "react-slick";

import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UpcomingEvent from "../UpcomingEvent";
import PageRoutes, { APIRoutes } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { GameData } from "../../utils/data";
import useAxiosPrivate, { getCurrentAuth } from "../../hooks/useAxiosPrivate";
import moment from "moment";
import { Button, Typography } from "@mui/material";

import GameCard from "../../Common/Component/GameCard";
import React from "react";
import useConfig from "../../hooks/useConfig";
import { HomePageApi } from "./Homepgae.Api";
import HttpService from "../../hooks/Https-services";
import PassesMain from "../Passes/Passes";

const HomePage: FC = () => {
  const [sliderRef, setSliderRef] = useState<any>(null);
  const [sliedRefHeader, setSlideRefHeader] = useState<any>(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [teamEventsList, setTeamEventsList] = useState<any>([]);
  const [subscriptionDetails, setSubscriptionDetails] = useState<any>({});
  const [slider, setSlider] = useState([]);
  const auth = getCurrentAuth();
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState(1);

  const configData = useConfig();
  const sliderSettings = {
    // removes default buttons
    arrows: false,
    slidesToShow: teamEventsList?.length > 3 ? 4 : teamEventsList?.length,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToScroll: 2,
    infinite: true,

    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const sliderSettingsHeader = {
    // removes default buttons
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const CheckUserSubscribe = async () => {
    try {
      const res = await HttpService.get(APIRoutes.CheckSubscribe);
      if (res?.data?.data?.isSubscribe) {
        setIsSubscribed(true);
      }
    } catch (error) {}
  };
  const GetUserSubscriptionData = async () => {
    if (!auth.AccessToken) {
      return;
    }
    try {
      const res = await HttpService.get(APIRoutes.GetSubscriptionDetials);

      if (res?.data?.data) {
        setSubscriptionDetails(res?.data?.data?.subscription);
        return res?.data?.data;
      }
    } catch (error) {}
  };

  const FetchTeamEvents = async () => {
    try {
      // setIsLoading(true);
      const params: any = {
        customer: configData.customer,
        status: "live",
        page: 1,
      };

      const result = await HttpService.getapiParams(APIRoutes.TeamEventsList, {
        params,
      });
      setTeamEventsList(result.data.data);
    } catch (error) {
    } finally {
      // setIsLoading(false);
    }
  };
  const GetSliderImages = async () => {
    try {
      // setIsLoading(true);

      const result = await HttpService.get(APIRoutes.Slider);

      setSlider(
        result?.data?.data?.sort(
          (a: any, b: any) => parseInt(a.Priority) - parseInt(b.Priority)
        )
      );
    } catch (error) {
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if (auth.AccessToken) {
      CheckUserSubscribe();
      GetUserSubscriptionData();
    }

    FetchTeamEvents();
    GetSliderImages();
  }, []);

  const handleWatch = (channelId: any) => {
    navigate(`${PageRoutes.UpcomingEvent}?channel_id=${channelId}`);
  };

  return (
    <Box>
      <div style={{ margin: "auto" }}>
        <div
          id="carouselExampleAutoplaying"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          {" "}
          <Slider ref={setSlideRefHeader} {...sliderSettingsHeader}>
            {slider?.map((el: any, index: any) => (
              <Box
                sx={{
                  backgroundImage: `url(${el?.Image})`,
                }}
                className={`carousel-item`}
              >
                <div
                  className="carousel-content"
                  style={{ gap: 8, display: "flex", flexDirection: "column" }}
                >
                  <Typography
                    sx={{
                      color: el?.FontColor || "#fff",
                      fontSize: {
                        xs: "14px",
                        md: `${el?.FontSize}px` || "14px",
                      },
                      fontWeight: 600,
                      lineHeight:
                        el?.FontSize > 50 ? { xs: "24px", md: "60px" } : "24px",
                      my: 1,
                    }}
                  >
                    {el?.DisplayText}
                  </Typography>
                  <button
                    className="button"
                    onClick={() => handleWatch(el?.WatchUrl)}
                  >
                    WATCH
                  </button>
                </div>
              </Box>
            ))}
          </Slider>
          <button
            className="carousel-control-prev"
            type="button"
            onClick={sliedRefHeader?.slickPrev}
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="prev"
          >
            <div className="carousel-control-prev-icon-div">
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </div>
          </button>
          <button
            onClick={sliedRefHeader?.slickNext}
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="next"
          >
            <div className="carousel-control-next-icon-div">
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </div>
          </button>
        </div>
      </div>

      {teamEventsList.length > 0 && (
        <Box sx={{ mt: 2 }} className="container-fluid">
          <Box>
            <h3 className="section-heading">UPCOMING EVENTS</h3>
          </Box>
          <br />
          {/* <Box> */}
          <Box sx={{ mx: { md: "40px" } }}>
            <Box sx={{ mb: 2, mt: "-60px", textAlign: "right" }}>
              <Typography
                sx={{ mx: 3.5, fontStyle: "italic", cursor: "pointer" }}
                variant="h6"
                onClick={() => {
                  navigate(PageRoutes.UpcomingEvent);
                }}
              >
                More
              </Typography>
              <Box>
                <Button
                  onClick={sliderRef?.slickPrev}
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#959799",
                  }}
                >
                  {" "}
                  &lt;{" "}
                </Button>
                <Button
                  onClick={sliderRef?.slickNext}
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#959799",
                  }}
                >
                  &gt;
                </Button>
              </Box>
            </Box>
            <Slider ref={setSliderRef} {...sliderSettings}>
              {teamEventsList?.map((game: any) => (
                <GameCard
                  subscriptionDetails={subscriptionDetails}
                  game={game}
                  auth={auth}
                  isSubscribed={isSubscribed}
                />
              ))}
            </Slider>
          </Box>
          {/* </Box> */}
        </Box>
      )}

      {configData?.planpage && (
        <div className="container-fluid">
          <br />
          <h3 className="section-heading">PLANS</h3>
          <br />
          <div className="container">
            <PassesMain isHomePage={true} />
            {/* <Passes isHomePage={true} /> */}
          </div>
        </div>
      )}
    </Box>
  );
};
export default HomePage;
